import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {catchError, map, of, switchMap} from 'rxjs';
import {HttpResponse} from '@angular/common/http';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  const handleAuthError = () => {
    authService.logout();
    return of(false);
  };

  return authService.authenticate().pipe(
    switchMap((isAuthenticated) => {
      if (isAuthenticated) {
        return of(true);
      } else {
        return authService.refreshToken().pipe(
          map((response: HttpResponse<any>) => {
            if (response.ok) {
              return true;
            } else {
              authService.logout();
              return false;
            }
          }),
          catchError(handleAuthError)
        );
      }
    }),
    catchError(handleAuthError)
  );
};
